/**
 * Configure and register global directives
 */
import type { App } from 'vue';
import { setupPermissionDirective } from './permission';
import { setupLoadingDirective } from './loading';
import { setupAutoFocusDirective } from './autoFocus';
import { setupAutoComplateOffDirective } from './autoComplateOff';
import { setupLoginDirective } from './login';
import VueDOMPurifyHTML from 'vue-dompurify-html';

export function setupGlobDirectives(app: App) {
  setupPermissionDirective(app);
  setupLoadingDirective(app);
  setupAutoFocusDirective(app);
  setupAutoComplateOffDirective(app);
  setupLoginDirective(app);
  app.use(VueDOMPurifyHTML, {
    default: {
      ADD_ATTR: ['target'], // 添加 'target' 到安全属性列表
    },
  });
}
